<!--
 * @description: 版本下载
 * @Author: wxy
 * @Date: 2020-02-11 12:03:04
 -->
<template>
  <div class="container">
    <block-title>图枢客户端下载</block-title>
    <el-row :gutter="50" :style="{ height: sty() }">
      <div class="downloadall" v-show="classIsMobile === 0">
        <div
          class="downDetail"
          v-for="(item, index) in list"
          :class="{ mobilDetail: item.id > 2 }"
          :key="index"
        >
          <img class="image" :class="{ imgClass: item.id < 3 }" :src="item.url" alt="" />
          <div class="tex">
            <div class="ban">{{ item.reminder }}</div>
            <div class="speak">{{ item.text }}</div>
          </div>
          <el-button
            size="small"
            :disabled="item.id === 2"
            @click="download(item.downloadUrl, item.url, item.url, item.name, index)"
          >
            <span class="btns">
              <span>立即下载</span>
              <img
                v-show="item.id > 2"
                src="@/assets/img/andriodQR.png"
                width="14px"
                height="14px"
                alt=""
              />
            </span>
          </el-button>
          <div class="noImage">{{ item.reminder }}</div>
          <el-row class="noImage">
            <el-col :span="6">
              <pi-qrcode :logo="logo" :logoScale="0.3" :text="urls" :cellSize="4"></pi-qrcode>
            </el-col>
          </el-row>
          <div class="noImage notits">打开手机扫一扫，立即下载</div>
        </div>
      </div>
      <and-mobile
        v-show="classIsMobile > 0"
        :classIsMobile="classIsMobile"
        :loadList="loadList"
      ></and-mobile>
    </el-row>
  </div>
</template>

<script>
import blockTitle from './blockTitle'
import PiQrcode from '@pillarjs/qrcode'
import { getLastPublishVersionByCode } from '@/api/dashboard'
import andMobile from './applicationCom/andMobile'
export default {
  name: '',
  components: { blockTitle, PiQrcode, andMobile },
  data() {
    return {
      urls: `${window.location.href}mobileDownload`,
      logo: require('@/assets/img/dashboard/logo.png'),
      list: [
        {
          id: 1,
          url: require('@/assets/img/window.png'),
          reminder: 'Windows版',
          text: '适用于win7/win8/win10',
          downloadUrl: ``,
          name: ``,
        },
        {
          id: 2,
          url: require('@/assets/img/mac.png'),
          reminder: 'Mac版',
          text: '适用于10.11或以上版本',
          downloadUrl: ``,
          name: ``,
        },
        {
          id: 3,
          url: require('@/assets/img/andriod.png'),
          reminder: 'Andriod版',
          text: '适用于Android5.0及以上',
          downloadUrl: '',
          name: '',
        },
        {
          id: 4,
          url: require('@/assets/img/ios.png'),
          reminder: 'iOS版',
          text: '适用于iOS10.0及以上版本',
          downloadUrl: '',
          name: '',
        },
      ],
      loadList: [],
      userAgent: '',
      classIsMobile: 0, // 0 win; 1 ios; 2 and; 3 chat;
    }
  },
  created() {
    this.getDownList()
    this.isMobile()
  },
  methods: {
    isMobile() {
      var system = {
        Windows: false,
        iPhone: false,
        Android: false,
        echat: false,
      }
      var chat = navigator.userAgent.toLowerCase()
      this.userAgent = chat
      let flag = navigator.userAgent.match(/(iPhone|ios|iPad|Android|windows|Mac)/i)
      system.Windows = flag[0] === 'Windows' || flag[0] === 'Mac' ? true : false
      system.iPhone = navigator.userAgent.match(/(iPhone|iPad|iPod|iOS)/i) != null ? true : false
      system.Android = flag[0] === 'Android' ? true : false
      system.echat = chat.match(/MicroMessenger/i) == 'micromessenger' ? true : false
      if (system.Windows) {
        this.classIsMobile = 0
        // win
      } else if (system.iPhone) {
        this.classIsMobile = 1
        if (system.echat) {
          this.classIsMobile = 3
        }
      } else {
        this.classIsMobile = 2
        if (system.echat) {
          this.classIsMobile = 4
        }
      }
    },

    sty() {
      if (this.classIsMobile === 0) return '350px'
      else if (this.classIsMobile > 0) return '0px'
    },

    async getDownList() {
      let res = await getLastPublishVersionByCode({ code: 'teamlink' })
      if (res.code === '200') {
        this.loadList = res.data
        let and = [],
          ios = [],
          exe = []
        this.loadList.map((item) => {
          if (item.typeId === 1) {
            and.push(item)
          } else if (item.typeId === 2) {
            ios.push(item.apkFileUrl)
          } else if (item.typeId === 3) {
            exe.push(item)
          }
        })
        this.list[0].downloadUrl = exe[0].apkFileUrl
        this.list[0].name = `TeamLink${exe[0].newVersion}.exe`
        this.list[2].downloadUrl = and[0].apkFileUrl
        this.list[2].name = `TeamLink${and[0].newVersion}.apk`
        this.list[3].downloadUrl = ios[0]
        console.log(this.list)
      } else {
        this.$message.warning(res.msg)
      }
    },
    download(downloadUrl, url, name, index) {
      if (index === 3) {
        window.open(url)
        return
      } else if (index === 1) {
        this.$message.warning('暂未开通')
      } else {
        let link = document.createElement('a')
        link.href = downloadUrl
        link.style.display = 'none'
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding-bottom: 180px;

  .downloadall {
    width: 1002px;
    margin: auto;
    display: flex;
    /*align-items: center;*/
    justify-content: center;
    position: relative;
    /*flex-wrap: wrap;*/
    /*border: 1px solid #DBDBDB;*/
    .downDetail:first-child {
      border: 1px solid #dbdbdb;
      border-right: 0;
    }

    .downDetail:nth-child(2) {
      border: 1px solid #dbdbdb;
      border-right: 0;
      border-left: 0;
    }

    .downDetail:nth-child(3) {
      border: 1px solid #dbdbdb;
      border-right: 0;
      border-left: 0;
    }

    .downDetail:last-child {
      border: 1px solid #dbdbdb;
      border-left: 0;
    }

    .downDetail {
      text-align: center;
      width: 250px;
      height: 310px;
      padding: 36px;

      .image {
        width: 60px;
        height: 60px;
      }

      .imgClass {
        /*filter: gray; !* IE6-9 *!*/
        filter: grayscale(1);
      }

      .noImage {
        display: none;
      }

      .tex {
        margin: 30px 0 50px 0;

        .ban {
          color: #333333;
          font-size: 18px;
          line-height: 25px;
        }

        .speak {
          color: #999;
          font-size: 14px;
          line-height: 20px;
        }
      }

      .el-button {
        // width: 107px;
        font-size: 14px;
        .btns {
          display: flex;
          align-items: center;
          img {
            margin-left: 5px;
          }
        }
      }

      .el-button:hover {
        background: #2587f6;
      }
    }

    .downDetail:hover {
      position: relative;
      bottom: 15px;
      height: 340px;
      box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.06);
      border: 0;

      .el-button {
        color: #2587f6;
        border: 1px solid #2587f6;
      }

      .el-button:hover {
        color: #ffffff;
      }
    }

    .mobilDetail:hover {
      position: relative;
      box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.06);
      background: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;

      .image {
        display: none;
      }

      .noImage {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        display: block;
        line-height: 50px;
      }

      .notits {
        font-size: 14px;
        color: #666666;
        text-align: center;
      }

      .tex {
        display: none;
      }

      .el-button {
        display: none;
      }
    }
  }
}
</style>
